import { DropzoneFile } from 'components/Dropzone/utils';
import { User } from 'models/User';
import { DataRoom } from './DataRoom';
import { ObjectValues } from 'types';
import { DataRoomShareableLinkConsumer } from 'models/ShareableLink';
import { PresignedFileResponse } from 'models/File';

export type DataRoomNda = {
  _id: string;

  name: string;
  //available when setup on ducign and link
  envelopeTemplateId: string;
  envelopeTemplateUploadedDate: Date;
  envelopeTemplateLinkedDate: Date;

  status: ShareableLinkNdaStatus;
  file: DropzoneFile;

  userId: string;
  user: Partial<User> | null;

  dataRoomId: string;
  dataRoom: Partial<DataRoom> | null;
};

export const SL_NDA_STATUS = {
  WAITING_CONNECTION: 'waiting_connection',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const;

export type ShareableLinkNdaStatus = ObjectValues<typeof SL_NDA_STATUS>;

export type UploadNdaFile = PresignedFileResponse & {
  dataRoomNda: DataRoomNda;
};

export type UploadNdaFileWithoutCreate = PresignedFileResponse & {
  uploadedFile: DropzoneFile;
  temporaryFileId: string;
};

export const SL_NDA_COPY = {
  [SL_NDA_STATUS.ACTIVE]: 'ndaConnected',
  [SL_NDA_STATUS.INACTIVE]: 'noNda',
  [SL_NDA_STATUS.WAITING_CONNECTION]: 'ndaProcessing',
};

export type DataRoomNdaSigner = {
  _id: string;

  //related to user on platform or data room shareable link consumer
  //USER
  userId: string;
  user: Partial<User> | null;

  //DATA ROOM SL CONSUMER
  dataRoomShareableLinkConsumerId: string;
  dataRoomShareableLinkConsumer: Partial<DataRoomShareableLinkConsumer> | null;

  dataRoomId: string;
  dataRoom: Partial<DataRoom> | null;

  //virtual props
  dataRoomNdaSignings: DataRoomNdaSigning[];
};

export type DataRoomNdaSigning = {
  _id: string;

  status: DataRoomNdaSigningStatus;
  docusignEnvelopeId: string;
  rejectionReason?: string;
  sentDate: Date;
  signedDate: Date;
  lastActionedAt: Date;
  numberOfNotSigned: number;
  timeline: DataRoomNdaSigningTimeline[];

  dataRoomNdaId: string;
  dataRoomNda: Partial<DataRoomNda> | null;

  dataRoomNdaSignerId: string;
  dataRoomNdaSigner: Partial<DataRoomNdaSigner> | null;
};

export const DATA_ROOM_NDA_SIGNING_STATUS = {
  PENDING: 'pending',
  NDA_EXECUTED: 'nda_executed',
  COUNTER_SIGNATURE_PENDING: 'counter_signature_pending',
  REJECTED: 'rejected',
  NOT_SENT: 'not_sent',
} as const;

export type DataRoomNdaSigningStatus = ObjectValues<
  typeof DATA_ROOM_NDA_SIGNING_STATUS
>;

export const DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION = {
  SENT: 'sent',
  SIGNED: 'signed',
  REMINDER: 'reminder',
  REJECTED: 'rejected',
  COUNTER_SENT: 'counter_sent',
  COUNTER_SIGNED: 'counter_signed',
} as const;

export type DataRoomNdaSigningTimelineAction = ObjectValues<
  typeof DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION
>;

export type DataRoomNdaSigningTimeline = {
  email: string;
  name: string;
  action: DataRoomNdaSigningTimelineAction;
  date: Date;
  rejectionReason?: string;
};
